import { render, staticRenderFns } from "./EnfoldUCD.vue?vue&type=template&id=07dcd503&scoped=true"
var script = {}
import style0 from "./EnfoldUCD.vue?vue&type=style&index=0&id=07dcd503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dcd503",
  null
  
)

export default component.exports